import { render, staticRenderFns } from "./TechSection.vue?vue&type=template&id=002c8f2a&scoped=true"
import script from "./TechSection.vue?vue&type=script&lang=js"
export * from "./TechSection.vue?vue&type=script&lang=js"
import style0 from "./TechSection.vue?vue&type=style&index=0&id=002c8f2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002c8f2a",
  null
  
)

export default component.exports